<h2 mat-dialog-title><mat-icon>inventory_2</mat-icon> {{ wh ? 'Редактировать склад' : 'Новый склад поставщика' }}</h2>
<form class="drop-padding" (ngSubmit)="save()" [formGroup]="whForm">
  <div class="warehouse-fields"><mat-form-field appearance="outline">
    <mat-label>Название</mat-label>
    <input matInput type="text" placeholder="Название" formControlName="description" required />
  </mat-form-field>
  <app-provider-selector [control]="providerControl"></app-provider-selector>
  <app-city-selector [control]="cityControl"></app-city-selector>
  <p class="form-hint">Укажите название, поставщика и город склада.</p></div>
  <p class="form-error" *ngIf="error" role="alert">{{ error }}</p>
  <div mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close [disabled]="saving">Отмена</button
    ><button mat-flat-button color="primary" type="submit" [disabled]="saving || !canSave">
      <mat-icon>save</mat-icon> {{ saving ? 'Сохраняем…' : 'Сохранить' }}
    </button>
  </div>
</form>
